import {SStyled} from "./theme";
import { Image } from 'rebass'

export const StyledPatternImage = SStyled(Image)`
width: auto;
object-fit: contain;
`